import {type FC, useEffect, useState} from 'react';
import type {IConnectionStatus} from '../types';
import {Bar, Count, Dot, Item, Name} from '../types/ConnectionStatus.styled.ts';
import useStreamingStore from "../../../store/useStreamingStore.ts";

const ConnectionStatus: FC = () => {
    const {streamingPollingData} = useStreamingStore();
    const [data, setData] = useState<IConnectionStatus[]>([
        {name: "미추홀", count: 0, color: "#60a5fa", participantAPIUrl: "https://mch-api.smartsilver.life/api/broadcasting/participant/"},
        {name: "강화군", count: 0, color: "#f472b6", participantAPIUrl: "https://ics-api.smartsilver.life/api/broadcasting/participant/"},
    ]);

    const linkList = streamingPollingData?.broadcast?.link_list;

    const fetchData = async () => {
        if (!linkList || linkList.length === 0) return;

        setData(prev => prev.map(item => {
            if (!linkList.includes(item.name)) {
                return {...item, count: 0};
            }
            return item;
        }));

        const targets = data.filter(item => linkList.includes(item.name));

        const results = await Promise.allSettled(
            targets.map(async (item) => {
                const res = await fetch(item.participantAPIUrl);
                const json = await res.json();
                return {name: item.name, count: json.total_participants ?? 0};
            })
        );

        setData(prev => prev.map(item => {
            const result = results.find((r, i) => r.status === 'fulfilled' && targets[i].name === item.name);
            if (result && result.status === 'fulfilled') {
                return {...item, count: result.value.count};
            }
            return item;
        }));
    };

    useEffect(() => {
        fetchData();
        const interval = setInterval(fetchData, 10 * 1000);
        return () => clearInterval(interval);
    }, [linkList]);

    return (
        <Bar>
            {data.filter(item => linkList?.includes(item.name))
                .map((item, i, filtered) => (
                    <Item key={item.name}>
                        <Dot color={item.color}/>
                        <Name color={item.color}>{item.name}</Name>
                        <Count color={item.color}>{item.count}</Count>
                        {i < filtered.length - 1 && <span style={{opacity: 0.4, color: 'black'}}>|</span>}
                    </Item>
                ))}
        </Bar>
    );
};

export default ConnectionStatus;
